import { render, staticRenderFns } from "./BaseCardGroup.vue?vue&type=template&id=58fb4f6b"
import script from "./BaseCardGroup.vue?vue&type=script&lang=js"
export * from "./BaseCardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports